<input class="display-none" #addFile multiple type="file" (change)="onFileSelected($event); addFile.value = ''"  accept="image/*" />
<img src="/assets/images/new-definitions/logo.svg" (click)="addLogo()">
